// Offers routes
export default [
  {
    path: 'locations-management',
    name: 'locations-management',
    redirect: 'locations-management/index',
    component: () =>
      import(
        /* webpackChunkName: "locationsManagement" */ '../views/locationsManagement/LocationsManagement.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'locationsManagementIndex',
        meta: {
          tabbable: true,
          tableKeys: ['locationsManagement'],
          filterKeys: ['locationsManagement'],
          formKeys: [],
          routePermissions: ['locationsView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "locationsManagementIndex" */ '../views/locationsManagement/LocationsManagementIndex.vue'
          ),
      },
    ],
  },
];
